import axios from 'axios';
import { useQuery } from 'react-query';
import * as yup from 'yup';
// import { IPatient, IReport } from '~/interfaces';
import { patientSchema } from '~/schemas';
import { reportSchema } from '../../schemas/reportSchema';
const responseSchema = yup
    .object()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup
        .object({
        patientReport: yup.array(reportSchema),
        patient: yup.array(patientSchema),
    })
        .required(),
});
export function usePatientHubQuery(reportId) {
    return useQuery(['patient_report', reportId], async function () {
        const response = await axios.get(`/api/patient/${reportId}`);
        console.log('Response: ');
        console.log(response);
        const { data } = await responseSchema.validate(response.data);
        console.log('Data: ');
        console.log(data);
        return data;
    }, { retry: false });
}
